export default {
  default: {
    othersText: {
      one: 'other',
      many: 'others',
    },
  },
}
